const PageNotFound: React.FC = () => {

    return (
        <div style={{ padding: '1rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                Page not found.
            </div>
        </div>
    );
}

export default PageNotFound;